
$(function() {

  var hoverTarget = '.header__inline-menu .mega-menu ';
  var enterEvent = 'mouseenter';
  var leaveEvent = 'mouseleave';  
  var _active = 'active hover menu-open';
  
  $(hoverTarget).on(enterEvent, function(e) {
      $(this).attr('open', true);
      $(this).addClass(_active);

  }).on(leaveEvent, function(e) {
      var _this = $(this);
      setTimeout(function() {
        _this.removeAttr('open');
        _this.removeClass(_active);

      }, 150);
  });

  $('summary.header__menu-item').on('click', function(){
    return false;
  });

})

